import { Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonMunicipalityCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { Municipality } from 'shell/models/municipality';
import { noop } from 'shell/utils/noop';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { transformResponseMunicipalityEditForeign } from 'system/geographic/utils/transformer-municipality-edit';
import FormMunicipality, { MunicipalityForm } from 'system/geographic/components/municipality/form';

const MunicipalityDetailForeignPage = (): React.ReactElement => {
  const params = useParams();

  const [municipalityData] = useHttpFetch<HttpResponse<Municipality>, MunicipalityForm>(
    `${__MUNICIPALITY_API_URL__}/geo/comune/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: transformResponseMunicipalityEditForeign,
    }
  );

  const municipality = municipalityData.data as MunicipalityForm;

  const navigate = useNavigate();

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonMunicipalityCrumbs, { name: 'Dettaglio Comune Estero' }]} />
      {municipalityData.isLoading || municipalityData.hasErrors || !municipality ? undefined : (
        <FormMunicipality
          title="Dettaglio Comune Estero"
          onOk={noop}
          initialValues={municipality}
          disabled
          isForeign
          onCancel={() => {
            navigate('/sistema/geografiche/comune');
          }}
        />
      )}
    </Fragment>
  );
};

MunicipalityDetailForeignPage.displayName = 'Municipality Detail foreign page component';

export default MunicipalityDetailForeignPage;
